import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import LayoutWithoutDrawer from "../../../../layouts/LayoutWithoutDrawer";
import { IGetTotalCreditForAssetConvertResponse, ITotalCreditItems, TMortgageType } from "../../../../models/trade.model";
import { GetTotalCreditForAssetConvert } from "../../../../services/trade.service";
import { IInnerStateHomeMenu } from "../IHomeMenu";
import { ITrade } from "./ITrade";
import Trade from "./trade";
import TradeHistory from "./tradeHistory";
import TradeProfile from "./tradeProfile";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";


export default function TradeContainer({ setTabChild }: IInnerStateHomeMenu) {
    const navigate = useNavigate();
    const [totalCreditForAsset, setTotalCreditForAsset] = useState<IGetTotalCreditForAssetConvertResponse>()
    const [selectedTotalCreditForAsset, setSelectedTotalCreditForAsset] = useState<ITotalCreditItems>()
    const [mortgageType, setMortgageType] = useState<TMortgageType>();
    const { mutate: GetTotalCreditForAssetConvertMutate, isLoading: GetTotalCreditForAssetConvertLoading } = useMutation(
        GetTotalCreditForAssetConvert,
        {
            onSuccess: (data: IGetTotalCreditForAssetConvertResponse) => {
                if (data) {
                    setTotalCreditForAsset(data)
                }
            },

            onError: () => { },
        }
    );

    useEffect(() => {
        setSelectedTotalCreditForAsset(totalCreditForAsset?.totalCreditItems.find((item) => item.mortgageType === mortgageType))
    }, [mortgageType, totalCreditForAsset])

    useEffect(() => {
        GetTotalCreditForAssetConvertMutate()
    }, [])

    const setState = (state: ITrade) => navigate(`/home/trade/${state === 'tradeProfile' ? '' : state}`);

    return (
        <LayoutWithoutDrawer>
            <Routes>
                <Route index element={<TradeProfile setState={setState} promotionItems={totalCreditForAsset?.promotionItems} totalCreditForAsset={totalCreditForAsset?.totalCreditItems} setMortgageType={setMortgageType} setTabChild={setTabChild} GetTotalCreditForAssetConvertLoading={GetTotalCreditForAssetConvertLoading} />} />
                <Route path="convert" element={<Trade setState={setState} selectedTotalCreditForAsset={selectedTotalCreditForAsset} />} />
                <Route path="history" element={<TradeHistory />} />
                <Route path="trade" element={<Navigate to="/home/trade/convert" replace />} />
                <Route path="tradeHistory" element={<Navigate to="/home/trade/history" replace />} />
                <Route path="*" element={<Navigate to="/home/trade" replace />} />
            </Routes>
        </LayoutWithoutDrawer>
    )
}
